module.exports = __webpack_public_path__ + "img/categoria-8.c1cd1bda.png";